import { createAction, props } from "@ngrx/store";
import { Administrator } from "src/app/_models/Administrator";
import { Userprofile } from "src/app/_models/Userprofile";
import { FormAdministratorActionTypes } from "src/app/constants/StoreConstants";

export const CreateAdmin = createAction(
    FormAdministratorActionTypes.CreateAdmin,
    props<{ admin: Administrator }>()
);
export const CreateAdminSuccess = createAction(
    FormAdministratorActionTypes.CreateAdminSuccess,
    props<{ createdAdmin: Userprofile }>()
);
export const CreateAdminError = createAction(
    FormAdministratorActionTypes.CreateAdminError,
    props<{ error: any }>()
);
export const ClearFormAdminstratorState = createAction(
    FormAdministratorActionTypes.ClearFormAdminstratorState
);